'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'redux-actions';
import { PERSIST_RESOLVED_REPORT } from 'analytics-tools-lib/constants/actionTypes';
const initialState = ImmutableMap();
export default handleActions({
  [PERSIST_RESOLVED_REPORT](state, {
    payload: {
      reportKey,
      report
    }
  }) {
    return state.set(reportKey, report);
  }
}, initialState);